export function bootstrap() {
  const tabsEls = Array.from(document.getElementsByClassName('c-tabs'));
  tabsEls.forEach(tabsEl => {
    const tabs = Array.from(tabsEl.getElementsByClassName('c-tabs__tab')),
          contents = Array.from(tabsEl.getElementsByClassName('c-tabs__content'));
    
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', e => {
        for (let j = 0; j < contents.length; j++) {
          if (j === i) {
            tabs[j].classList.add('c-tabs__tab--active');
            contents[j].classList.add('c-tabs__content--active');
          } else {
            tabs[j].classList.remove('c-tabs__tab--active');
            contents[j].classList.remove('c-tabs__content--active');
          }
        }
      });
    }
  });
}
